/**
 * Resolve the device's company token.
 *
 * On a real device the Android shell injects `window.AppConfig.getCompanyToken()`,
 * returning the token baked into the APK flavor (pm | nzks). In dev / a plain browser
 * the shell is absent, so we fall back to the build-time `VITE_DEVICE_TOKEN`.
 *
 * Read fresh from the shell each call — never persisted in browser storage.
 */
export function resolveDeviceToken(): string {
  const fromShell = window.AppConfig?.getCompanyToken?.();
  if (typeof fromShell === "string" && fromShell.length > 0) {
    return fromShell;
  }
  return import.meta.env.VITE_DEVICE_TOKEN ?? "";
}

/** The device/operator id used for audit logging (a label, not a credential). */
export function resolveDeviceId(): string {
  return import.meta.env.VITE_DEVICE_ID ?? "tc58-web";
}
